// @flow
import prop from 'ramda/es/prop';
import path from 'ramda/es/path';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import * as orgsTypes from 'app/common/constants/schools/types';


export default function useStatementsTitle() {
  const { t } = useTranslation('app');

  const { student, loadingUser } = useSelector(state => state.user, shallowEqual);
  const studentId = prop('id', student);

  const isUserStudent = Boolean(studentId);
  const { loading: loadingStudents, data: studentsData } = useSelector(state => state.students, shallowEqual);
  const orgTypeByStudent = path([studentId, 'orgType'], studentsData);
  const { school_type: orgTypeByDealer } = useSelector(state => state.dealer, shallowEqual);
  const orgType = isUserStudent ? orgTypeByStudent : orgTypeByDealer;

  const targetTitle = orgType === orgsTypes.HIGH_SCHOOL
    ? t('app_main_menu_item6_high_school')
    : t('app_main_menu_item6');


  return [targetTitle, loadingUser || loadingStudents];
}
